var exports = {
  "xl": "languageList__0mbjU5",
  "y2": "languageListItem__Y9dtVH",
  "O6": "languageItem__H1dOD6",
  "nO": "languageLink__V8hWIO",
  "m5": "languageDot__gECl8O",
  "cL": "languageName__OweiHW",
};

module.exports = exports;
